import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { Button, Pagination, Space } from 'tdesign-react';

import NovaDialog from '@/components/dialog';
import { UrlInfo } from '@/interface/aigc';

import AigcVideoComponent from '../AigcVideoComponent';
import styles from './index.module.less';

export interface AigcVideoDialogProps {
  visible: boolean;
  onClose: () => void;
  onConfirm: (selectedVideo: UrlInfo, promptText: string) => Promise<void>;
  data: {
    promptText: string,
  };
  isHorizontal: boolean;
}

const AigcVideoDialog: React.FC<AigcVideoDialogProps> = (props) => {
  const { visible, onClose, onConfirm, data, isHorizontal } = props;
  const [src, setSrc] = useState<UrlInfo>();
  const [prompt, setPrompt] = useState('');
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    size: 10,
    total: 0,
  });

  useEffect(() => {
    if (!visible) {
      setSrc(undefined);
      setPagination(pre => ({ ...pre, page: 1 }));
      setConfirmLoading(false);
    }
  }, [visible]);

  const handleConfirm = async () => {
    try {
      setConfirmLoading(true);
      await onConfirm({
        url: src?.url || '',
        name: src?.name || '未命名',
      }, prompt);
      onClose();
    } catch (err) {
      console.error(err);
    } finally {
      setConfirmLoading(false);
    }
  };

  const getHeader = () => (
		<div className={styles.modalTitle}>
			<span style={{ flexGrow: 1 }}>AI 视频生成</span>
		</div>
  );

  const getFooter = () => (
    <div className={classNames('nova-modal-fixed-bottom-wrapper-end', styles.footer)}>
      <Pagination
        total={pagination.total}
        totalContent={false}
        defaultPageSize={10}
        pageSizeOptions={[5, 10, 20, 50, 100]}
        current={pagination.page}
        pageSize={pagination.size}
        onChange={v => setPagination(pre => ({
          ...pre,
          page: v.current,
          size: v.pageSize,
        }))}
      />
      <Space size={10}>
        <Button
          className="nova-info-button"
          size="medium"
          block
          theme="default"
          disabled={confirmLoading}
          onClick={onClose}
        >
          取消
        </Button>
        <Button
          className="nova-info-button"
          size="medium"
          block
          loading={confirmLoading}
          onClick={handleConfirm}
        >
          确定
        </Button>
      </Space>
    </div>
  );

  const dialogConfig = {
    visible,
    closeBtn: false,
    destroyOnClose: true,
    closeOnOverlayClick: false,
    width: '70vw',
    height: '700px',
    style: { overflow: 'auto' },
    className: styles.dialog,
    onCancel: onClose,
    onConfirm: handleConfirm,
    onClose,
    header: getHeader(),
    footer: getFooter(),
  };

  const getSrc = (src: UrlInfo) => {
    setSrc(src);
  };

  const getPrompt = (prompt: string) => {
    setPrompt(prompt);
  };

  return (
		<NovaDialog dialogConfig={dialogConfig}>
      <AigcVideoComponent
				visible={visible}
				data={data}
				getSrc={getSrc}
				getPrompt={getPrompt}
        isHorizontal={isHorizontal}
        pagination={pagination}
        onPageChange={v => setPagination(v)}
			/>
		</NovaDialog>
  );
};

export default AigcVideoDialog;
